import { App, Button, Form, Input, InputNumber, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { GET } from '../../../utils/requestActionConstants';
import { API_ROUTE } from '../../../utils/commonConstants';
import { fetcher } from '../../../helpers/processRequest';
import useSWR from 'swr';
import { addUser, setError, updateUser } from '../../../store/slices/userSlice';

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 6,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 14,
    },
  },
};

function AddUser({ onSwitchTab, tabProps = {} }) {
  const {notification} = App.useApp();
  const user = useSelector(state => state.userSlice.user);
  const error = useSelector(state => state.userSlice.error);
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  useEffect(() => {
    loadValues();
  }, [user]);

  const loadValues = () => {
    if (user.id) {
      form.setFieldsValue(user);
    } else {
      form.resetFields();
    }
  }

  const saveUser = ({password2, ...cleanData}) => {
    if (user.id) {
      dispatch(updateUser({ userId: user.id, userData: cleanData }));
    } else {
      dispatch(addUser({ userData: cleanData }));
    }
  }

  useEffect(() => {
    if (error) {
      notification.error({
        message: "Request Failed!",
        description: error,
        placement: 'topRight',
        onClose: function () {
          dispatch(setError(null));
        }
      });
    }
  }, [error])

  return (
    <div>
      <div className='text-center py-2 mb-10 mt-5 font-bold p-5 rounded-lg mx-auto w-fit text-xl '>{user.id ? "Update user" : "Add New user"}</div>
      <Form
        form={form}
        layout='verticle'
        {...formItemLayout}
        style={{
          maxWidth: 600,
          margin: 'auto'
        }}
        onFinish={saveUser}
      >
        <Form.Item
          label="User Name"
          name="name"
          rules={[
            {
              required: true,
              message: 'Enter User Name Here',
            },
          ]}
        >
          <Input placeholder='Name of the user' />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            {
              required: true,
              message: 'Enter email',
            },
          ]}
        >
          <Input placeholder='Enter your email' />
        </Form.Item>
        <Form.Item
          label="Role"
          name="role"
          rules={[
            {
              required: true,
              message: 'Select Role',
            },
          ]}
        >
          <Select placeholder="Select User Role">
            <Select.Option value={'admin'}>Admin</Select.Option>
            <Select.Option value={'customer'}>Customer</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Password" name="password" rules={[{ required: true }]}>
          <Input.Password />
        </Form.Item>

        <Form.Item
          label="Confirm Password"
          name="password2"
          dependencies={['password']}
          rules={[
            {
              required: true,
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('The new password that you entered do not match!'));
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item wrapperCol={{ sm: { offset: 6, span: 14 }, xs: { offset: 0, span: 14 } }}>
          <div className='flex justify-between'>
            <div>{user.id ? <Button onClick={loadValues}>Revert Changes</Button> : <></>}</div>
            <div className='flex'>
              <Button danger type='text' htmlType='reset'>Clear</Button>
              <Button type='primary' htmlType='submit'>{user.id ? "Update" : "Save"}</Button>
            </div>
          </div>
        </Form.Item>
      </Form>
    </div>
  )
}

export default AddUser